import MessageClient from "./MessageClient";
import Helpers from "../../commons/helpers";
import { Constants } from "../../constants/constants";
import { ICommunity, IMultiLanguageContent, IPagedList } from "../../commons/interfaces";

export type IRequestGetPagedCommunity = {
    type?: number;
    clientId: string;
    serviceCode: string;
    tenantCode: string;
    organizationId: string;
    pageNumber: number;
    pageSize: number;
    orderby?: string;
    searchText?: string;

    totalCount?: number;
};

export type IRequestUpdateTopic = {
    serviceCode: string;
    tenantCode: string;
    type: number;
    organizationId: string;
    name: string;
    coverImageUrl: string;
    coverImage: string;
    avatarImageUrl: string;
    avatarImage: string;
    description: IMultiLanguageContent;
    setting: string;
    metaHeader: string;
    id: string;
    updateTime?: string;
};

export type IRequestCreateTopic = Omit<IRequestUpdateTopic, "id">;

const CommunityService = {
    getPaged: async (data: IRequestGetPagedCommunity): Promise<IPagedList<ICommunity>> => {
        const pamams = Helpers.handleFormatParams(data);
        const result = await MessageClient().get(`${Constants.ApiPath.COMMUNITY.GET_PAGED}?${pamams}`);
        return result.data.result;
    },

    getDetail: async (id: string): Promise<ICommunity> => {
        const result = await MessageClient().get(Constants.ApiPath.COMMUNITY.GET_DETAIL + `/${id}`);
        return {
            ...result.data.result,
            setting: result.data.result?.setting ? JSON.parse(result.data.result?.setting) : {},
        };
    },

    create: async (data: IRequestCreateTopic): Promise<ICommunity> => {
        const result = await MessageClient().post(Constants.ApiPath.COMMUNITY.CREATE, data);
        return {
            ...result.data.result,
            setting: result.data.result?.setting ? JSON.parse(result.data.result?.setting) : {},
        };
    },

    update: async (data: IRequestUpdateTopic): Promise<ICommunity> => {
        const result = await MessageClient().put(Constants.ApiPath.COMMUNITY.UPDATE, data);
        return {
            ...result.data.result,
            setting: result.data.result?.setting ? JSON.parse(result.data.result?.setting) : {},
        };
    },

    publish: async (id: string): Promise<ICommunity> => {
        const result = await MessageClient().put(`${Constants.ApiPath.COMMUNITY.PUBLISH}/${id}`, { id });
        return result.data.result;
    },

    unpublish: async (id: string): Promise<ICommunity> => {
        const result = await MessageClient().put(`${Constants.ApiPath.COMMUNITY.UNPUBLISH}/${id}`, { id });
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(Constants.ApiPath.COMMUNITY.DELETE + `/${id}`);
        return result.data.result;
    },

    join: async (id: string) => {
        const result = await MessageClient().post(
            `${Constants.ApiPath.COMMUNITY.JOIN}/${id}`
        );
        return result.data.result;
    },
};

export default CommunityService;
